import { Route, Routes } from 'react-router';

import { commonRoutes, redirectRoute } from '@/shared/helpers/routing';

import { useAuthToken } from '../../shared/hooks/useAuthToken';
import { useFeatureFlags } from '../../shared/providers/FeatureFlagProvider';
import { AccountDetails } from './accounts/account-details/account-details';
import { AccountList } from './accounts/account-list/account-list';
import { BillDetails } from './billings/bill-details/bill-details';
import { BillList } from './billings/bill-list/bill-list';
import { CarrierAccountDetails } from './carriers/carrier-account-details/carrier-account-details';
import { CarrierAccountList } from './carriers/carrier-account-list/carrier-account-list';
import { CarrierDetails } from './carriers/carrier-details/carrier-details';
import { CarrierList } from './carriers/carrier-list/carrier-list';
import { CarrierServiceDetails } from './carriers/carrier-service-details/CarrierServiceDetails';
import { CarrierServiceList } from './carriers/carrier-service-list/carrier-service-list';
import { FulfillmentProfileList } from './fulfillment-profiles/fulfillment-profile-list/fulfillment-profile-list';
import { LocationDetails } from './locations/location-details/location-details';
import { LocationList } from './locations/location-list/location-list';
import { CreateQuote } from './quotes/create-quote/create-quote';
import { ShipmentList } from './shipments/shipment-list/ShipmentList';
import { ShippingPriceDetails } from './shipping-prices/shipping-price-details/ShippingPriceDetails';
import { ShippingPriceList } from './shipping-prices/shipping-price-list/shipping-price-list';
import { CreateScenarioPage } from './simulation/create-scenario-page/create-scenario-page';
import { CreateSimulationPage } from './simulation/create-simulation-page/create-simulation-page';
import { ScenarioDetails } from './simulation/scenario-details/scenario-details';
import { SimulationDetails } from './simulation/simulation-details/simulation-details';
import { SimulationList } from './simulation/simulation-list/simulation-list';

export function PlatformRoutes() {
  const { isInvencoUser } = useAuthToken();
  const { getFeatureFlag } = useFeatureFlags();
  const showSimulation = getFeatureFlag('simulation-ui');

  return (
    <Routes>
      {redirectRoute('/', '/accounts')}

      <Route path="/accounts">
        <Route index element={<AccountList />} />
        <Route path="new" element={<AccountDetails isNew />} />
        <Route path=":id" element={<AccountDetails />} />
      </Route>

      <Route path="/locations">
        <Route index element={<LocationList />} />
        <Route path=":id" element={<LocationDetails />} />
      </Route>

      <Route path="/shipping">
        {redirectRoute('', 'carriers')}
        <Route path="carriers">
          <Route index element={<CarrierList />} />
          <Route path=":id" element={<CarrierDetails />} />
        </Route>

        <Route path="carrier-services">
          <Route index element={<CarrierServiceList />} />
          <Route path=":id" element={<CarrierServiceDetails />} />
        </Route>

        <Route path="carrier-accounts">
          <Route index element={<CarrierAccountList />} />
          <Route path=":id" element={<CarrierAccountDetails />} />
        </Route>

        <Route path="prices">
          <Route index element={<ShippingPriceList />} />
          <Route path=":id" element={<ShippingPriceDetails />} />
        </Route>

        <Route path="fulfillment-profiles">
          <Route index element={<FulfillmentProfileList />} />
        </Route>

        <Route path="shipments" element={<ShipmentList />} />
        <Route path="quote" element={<CreateQuote />} />
      </Route>

      <Route path="/bills">
        <Route index element={<BillList />} />
        <Route path=":id" element={<BillDetails />} />
      </Route>

      {showSimulation && (
        <Route path="/simulations">
          <Route index element={<SimulationList />} />
          <Route path="new" element={<CreateSimulationPage />} />
          <Route path=":id">
            <Route index element={<SimulationDetails />} />
            <Route path="scenarios/new" element={<CreateScenarioPage />} />
            <Route path="scenarios/:scenarioId" element={<ScenarioDetails />} />
          </Route>
        </Route>
      )}

      {commonRoutes(isInvencoUser)}
    </Routes>
  );
}
